import React, { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Modal } from 'react-responsive-modal';
import { MasterMessage } from '../../../masters/masterMessages';
import Grid from '@mui/material/Grid';
import ButtonGeneral from '../../components/general/buttons/buttonGeneral';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import DropZoneField from '../../components/general/fields/dropzoneField';
import ModalLoading from '../../components/general/loading/modalLoading';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import { asyncPostCaseCreation } from '../../../services/caseCreation.service';
import Swal from 'sweetalert2';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    saveLoad: (value: boolean) => void;
};

const ModalCaseCreation = ({ open, onClose, saveLoad }: Props) => {
    const [files, setFiles] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const { titleNew, titleModalLoading, messageModalLoading, messageError } =
        MasterMessage.caseCreation;
    const [dataBody, setDataBody] = useState<any>();

    const handleClick = () => {
        if (files.length > 0) {
            setLoading(true);
            setDataBody(undefined);
            asyncPostCaseCreation(files[0])
                .then((body: any) => {
                    if (body.items !== undefined) {
                        saveLoad(true);
                        setDataBody(body.items);
                    } else {
                        Swal.fire({
                            title: 'Error Carga',
                            text: messageError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    }
                })
                .finally(() => setLoading(false));
        } else {
            SwalCustomClass.fire({
                text: 'Debes seleccionar algún archivo',
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };

    return (
        <>
            <Modal
                open={open}
                onClose={() => onClose(false)}
                closeOnOverlayClick={false}
                styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
            >
                <Box>
                    <Typography
                        color="primary"
                        component="h3"
                        sx={{
                            fontSize: { lg: 27, xs: 23 },
                            mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                        }}
                    >
                        {titleNew}
                    </Typography>
                    <hr />
                    <Box mt={3} px={1}>
                        <Grid
                            container
                            spacing={{ xs: 2, md: 2 }}
                            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        >
                            <Grid item xs={12}>
                                {dataBody ? (
                                    <>
                                        Se cargaron {dataBody.length} registros
                                        exitosamente.
                                        {dataBody.withProblem.length > 0 && (
                                            <Grid mt={2}>
                                                <Grid>
                                                    Se econtro{' '}
                                                    {
                                                        dataBody.withProblem
                                                            .length
                                                    }{' '}
                                                    registros con problema:
                                                </Grid>
                                                <Grid
                                                    width="100%"
                                                    height="150px"
                                                    overflow="auto"
                                                    mt={1}
                                                >
                                                    {dataBody.withProblem.map(
                                                        (item: any) => (
                                                            <Grid>
                                                                Caso con
                                                                documento{' '}
                                                                <b>
                                                                    {
                                                                        item.documento
                                                                    }
                                                                </b>{' '}
                                                                y global id{' '}
                                                                <b>
                                                                    {
                                                                        item.globalInteractionId
                                                                    }
                                                                </b>
                                                                {item.isInvalidGlobalId && (
                                                                    <Chip
                                                                        label="Global id incorrecto"
                                                                        style={{
                                                                            marginLeft:
                                                                                '10px',
                                                                        }}
                                                                        color="error"
                                                                    />
                                                                )}
                                                                {(item.isDuplicatedInDB ||
                                                                    item.isDuplicatedInLoad) && (
                                                                    <Chip
                                                                        label="Global id duplicado"
                                                                        style={{
                                                                            marginLeft:
                                                                                '10px',
                                                                        }}
                                                                        color="error"
                                                                    />
                                                                )}
                                                                {item.incompleteData && (
                                                                    <Chip
                                                                        label="Datos incompletos"
                                                                        style={{
                                                                            marginLeft:
                                                                                '10px',
                                                                        }}
                                                                        color="error"
                                                                    />
                                                                )}
                                                                <hr />
                                                            </Grid>
                                                        )
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                    </>
                                ) : (
                                    <DropZoneField
                                        name="Cargue Masivo"
                                        maxFiles={1}
                                        accept=".xlsx"
                                        onChange={(value) => setFiles(value)}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                {!dataBody ? (
                                    <>
                                        <ButtonGeneral
                                            onClick={() => handleClick()}
                                            startIcon={
                                                <FileUploadIcon color="secondary" />
                                            }
                                            title="Cargar"
                                            sx={{ mr: 1 }}
                                        />
                                        <ButtonGeneral
                                            onClick={() => onClose(false)}
                                            startIcon={
                                                <CancelIcon color="secondary" />
                                            }
                                            title="Cancelar"
                                        />
                                    </>
                                ) : (
                                    <ButtonGeneral
                                        onClick={() => onClose(false)}
                                        startIcon={
                                            <CheckIcon color="secondary" />
                                        }
                                        title="Aceptar"
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
            {loading ? (
                <ModalLoading
                    open={loading}
                    title={titleModalLoading}
                    message={messageModalLoading}
                />
            ) : null}
        </>
    );
};

export default ModalCaseCreation;
